import { GameWithScore, StudentResultsStore } from "../../../react/students/StudentResultsStore"

export class PongStore {

    static saveUserScore = (smoked: number) => StudentResultsStore.instance.addScore(GameWithScore.ADDICTION_PONG, smoked)

    static getScores = () => StudentResultsStore.instance.findRecentScores(GameWithScore.ADDICTION_PONG).slice(0, 6)

}
